<template>
  <div>
    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="p-1">
          <h5>Detail Invoice</h5>

          <v-row>
            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-text-field
                label="No Nota"
                dense
                small-chips
                hide-details
                disabled
                outlined
                v-model="formData.nomor_nota"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4" class="py-0">
              <v-text-field
                label="Ditagih Kepada"
                type="text"
                dense
                small-chips
                hide-details
                disabled
                outlined
                v-model="formData.customer.nama"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" class="py-0">
              <v-text-field
                label="Total Koli"
                type="text"
                disabled
                outlined
                dense
                small-chips
                hide-details
                v-model="total_koli"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" class="py-0">
              <v-text-field
                label="Total Kubikasi"
                type="text"
                disabled
                outlined
                dense
                small-chips
                hide-details
                v-model="total_kubikasi"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" class="py-0">
              <v-text-field
                label="Total Tonase"
                type="text"
                disabled
                outlined
                dense
                small-chips
                hide-details
                v-model="total_tonase"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <h5>Nilai Nota</h5>

              <table class="detail-table">
                <tbody>
                  <tr>
                    <td>Freight Charge I:</td>
                    <td class="text-center">
                      {{ formData.i_jumlah }} {{ formData.i_satuan }}
                    </td>
                    <td>x</td>
                    <td class="text-center">
                      {{ formatCurrency(formData.i_harga) }}
                    </td>
                    <td>=</td>
                    <td>{{ formatCurrency(formData.i_total) }}</td>
                  </tr>
                  <tr>
                    <td>Freight Charge II:</td>
                    <td class="text-center">
                      {{ formData.ii_jumlah }} {{ formData.ii_satuan }}
                    </td>
                    <td>x</td>
                    <td class="text-center">
                      {{ formatCurrency(formData.ii_harga) }}
                    </td>
                    <td>=</td>
                    <td>{{ formatCurrency(formData.ii_total) }}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-right">
                      {{ formData.biaya_lain }}
                    </td>
                    <td>=</td>
                    <td>{{ formatCurrency(formData.biaya_lain_total) }}</td>
                  </tr>
                  <tr>
                    <td colspan="5"></td>
                    <td>
                      Rp.
                      {{
                        formatCurrency(
                          Math.abs(formData.i_total) +
                            Math.abs(formData.ii_total) +
                            Math.abs(formData.biaya_lain_total)
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h5>Laporan Kejadian</h5>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card tile>
        <v-card-text class="p-1">
          <v-row>
            <!-- <v-col cols="12" md="4" sm="4">
              <v-text-field
                label="Nilai Nota"
                type="number"
                dense
                small-chips
                hide-details
                disabled
                v-model="total_pelunasan"
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                label="Kolektor"
                dense
                hide-details
                v-model="formData.kolektor.user_id"
                :items="items.kolektor"
                :loading="loading.fetchKolektor"
                :disabled="loading.fetchKolektor"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Tgl Pelunasan"
                type="date"
                dense
                small-chips
                hide-details
                @blur="updateTglLunasNota"
                @keydown.enter="updateTglLunasNota"
                v-model="formData.tgl_lunas"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <v-text-field
                label="Keterangan Pelunasan"
                type="text"
                dense
                small-chips
                hide-details
                @blur="updateKeteranganPelunasan"
                @keydown.enter="updateKeteranganPelunasan"
                v-model="formData.keterangan_pelunasan"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card tile>
        <v-card-text class="p-1">
          <h5>Pemotongan</h5>

          <v-row>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Total Claim"
                type="number"
                dense
                small-chips
                hide-details
                v-model="claimFormData.total"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="No LK"
                type="text"
                dense
                small-chips
                hide-details
                v-model="claimFormData.no_laporan"
                @keydown.enter="checkNoLaporan"
                :loading="loading.findLaporan"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Kategori Claim"
                type="text"
                dense
                small-chips
                hide-details
                v-model="claimFormData.kategori"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" sm="5">
              <v-text-field
                label="Keterangan Claim"
                type="text"
                dense
                small-chips
                hide-details
                v-model="claimFormData.keterangan"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <v-btn
                small
                color="primary"
                :loading="loading.addClaim"
                :disabled="loading.addClaim"
                @click="addClaim"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <table width="100%">
            <thead>
              <th>No</th>
              <th>No LK</th>
              <th>Total Claim</th>
              <th>Kategori</th>
              <th>Keterangan</th>
              <th class="text-center">Action</th>
            </thead>
            <tbody>
              <tr v-if="loading.fetchClaim">
                <td colspan="6">
                  <v-text-field color="success" loading disabled></v-text-field>
                </td>
              </tr>
              <tr v-for="(claim, i) in data.claims" :key="claim.id">
                <td>{{ i + 1 }}</td>
                <td>{{ claim.no_laporan }}</td>
                <td>{{ formatCurrency(claim.total) }}</td>
                <td>{{ claim.kategori }}</td>
                <td>{{ claim.keterangan }}</td>
                <td class="text-center">
                  <v-icon @click="deleteClaim(claim.id)">mdi-delete</v-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <v-card tile>
        <v-card-text class="p-1">
          <h5>Giro</h5>

          <v-row>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nama Bank"
                type="text"
                dense
                small-chips
                hide-details
                v-model="giroFormData.nama_bank"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nomor Giro"
                type="text"
                dense
                small-chips
                hide-details
                v-model="giroFormData.nomor_giro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nominal Giro"
                type="number"
                dense
                small-chips
                hide-details
                v-model="giroFormData.nominal_giro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Tgl Cair"
                type="date"
                dense
                small-chips
                hide-details
                v-model="giroFormData.tgl_cair"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <v-btn
                small
                color="primary"
                :loading="loading.addGiro"
                :disabled="loading.addGiro"
                @click="addGiro"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <table width="100%">
            <thead>
              <th>No</th>
              <th>Nama Bank</th>
              <th>Nomor Giro</th>
              <th>Nominal</th>
              <th>Tgl Cair</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr v-if="loading.fetchGiro">
                <td colspan="6">
                  <v-text-field color="success" loading disabled></v-text-field>
                </td>
              </tr>
              <tr v-for="(giro, i) in data.giros" :key="giro.id">
                <td>{{ i + 1 }}</td>
                <td>{{ giro.nama_bank }}</td>
                <td>{{ giro.nomor_giro }}</td>
                <td>{{ formatCurrency(giro.nominal_giro) }}</td>
                <td>{{ formatDate(giro.tgl_cair) }}</td>
                <td>
                  <v-icon @click="deleteGiro(giro.id)">mdi-delete</v-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Pop Up fetch invoice data -->
    <FindNomorNota :openModal="!haveNomorNota" @close-modal="setInvoiceData" />

    <!-- Show Laporan Kejadian Info -->
    <ShowLaporanModal
      :openModal="showLaporanModal"
      :data="data.laporan"
      @close-modal="
        showLaporanModal = false;
        this.data.laporan = {};
      "
    />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="formatForm"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    ShowLaporanModal: () =>
      import("@/components/LaporanKejadian/ShowModal.vue"),
    FindNomorNota: () => import("@/components/Invoice/PelunasanModal.vue")
  },
  data() {
    return {
      haveNomorNota: false,
      showLaporanModal: false,
      formData: {
        i_total: 0,
        ii_total: 0,
        biaya_lain_total: 0,
        customer: {
          nama: ""
        },
        kolektor: {
          user_id: ""
        },
        keterangan_pelunasan: "",
        invoice_detil: [],
        i_jumlah: "",
        i_satuan: "",
        i_harga: "",
        i_total: "",
        ii_jumlah: "",
        ii_satuan: "",
        ii_harga: "",
        ii_total: "",
        biaya_lain: "",
        biaya_lain_total: ""
      },
      claimFormData: {
        total: "",
        no_laporan: "",
        kategori: "",
        keterangan: ""
      },
      giroFormData: {
        nama_bank: "",
        nomor_giro: "",
        nominal_giro: "",
        tgl_cair: ""
      },
      loading: {
        fetchKolektor: false,
        fetchClaim: false,
        fetchGiro: false,
        addClaim: false,
        addGiro: false,
        findLaporan: false
      },
      items: {
        kolektor: []
      },
      data: {
        claims: [],
        giros: [],
        laporan: {}
      },
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    total_pelunasan() {
      let i_total =
        typeof this.formData.i_total != "number" ? 0 : this.formData.i_total;
      let ii_total =
        typeof this.formData.ii_total != "number" ? 0 : this.formData.ii_total;
      let biaya_lain_total =
        typeof this.formData.biaya_lain_total != "number"
          ? 0
          : this.formData.biaya_lain_total;

      return this.formatCurrency(i_total + ii_total + biaya_lain_total);
    },
    total_koli() {
      let total = 0;

      this.formData.invoice_detil.forEach(ttb => {
        ttb.ttb.ttbrinci.forEach(rinci => {
          total += parseInt(rinci.koli);
        });
      });

      return total;
    },
    total_kubikasi() {
      let total = 0;

      this.formData.invoice_detil.forEach(ttb => {
        ttb.ttb.ttbrinci.forEach(rinci => {
          total += parseFloat(rinci.m3);
        });
      });

      return total.toFixed(2);
    },
    total_tonase() {
      let total = 0;

      this.formData.invoice_detil.forEach(ttb => {
        ttb.ttb.ttbrinci.forEach(rinci => {
          total += parseFloat(rinci.ton);
        });
      });

      return total.toFixed(2);
    }
  },
  methods: {
    async checkNoLaporan() {
      this.loading.findLaporan = true;

      await axios
        .get(`laporan-kejadian/${this.claimFormData.no_laporan}`)
        .then(res => {
          this.loading.findLaporan = false;

          if (!res.data.id) {
            alert("No Laporan Tidak Ditemukan");

            return;
          }

          this.data.laporan = res.data;
          this.showLaporanModal = true;
        })
        .catch(err => {
          this.loading.findLaporan = false;

          alert(err.response.data.message);
        });
    },
    async fetchKolektor() {
      this.loading.fetchKolektor = true;

      await axios
        .get(`kolektor`)
        .then(res => {
          this.items.kolektor = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.fetchKolektor = false;
        })
        .catch(err => {
          this.loading.fetchKolektor = false;

          alert(err.response.data.message);
        });
    },
    fetchClaim() {
      this.loading.fetchClaim = true;

      axios
        .get(`invoice/fetch-claim?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          this.data.claims = res.data;

          this.loading.fetchClaim = false;
        })
        .catch(err => {
          this.loading.fetchClaim = false;

          alert(err.response.data.message);
        });
    },
    fetchGiro() {
      this.loading.fetchGiro = true;

      axios
        .get(`invoice/fetch-giro?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          this.data.giros = res.data;

          this.loading.fetchGiro = false;
        })
        .catch(err => {
          this.loading.fetchGiro = false;

          alert(err.response.data.message);
        });
    },
    addClaim() {
      this.loading.addClaim = true;

      axios
        .post(
          `invoice/add-claim?nomor_nota=${this.formData.nomor_nota}`,
          this.claimFormData
        )
        .then(res => {
          this.claimFormData = {
            total: "",
            no_laporan: "",
            kategori: "",
            keterangan: ""
          };

          this.fetchClaim();

          this.loading.addClaim = false;
        })
        .catch(err => {
          this.loading.addClaim = false;

          alert(err.response.data.message);
        });
    },
    addGiro() {
      this.loading.addGiro = true;

      axios
        .post(
          `invoice/add-giro?nomor_nota=${this.formData.nomor_nota}`,
          this.giroFormData
        )
        .then(res => {
          this.giroFormData = {
            nama_bank: "",
            nomor_giro: "",
            nominal_giro: "",
            tgl_cair: ""
          };

          this.fetchGiro();

          this.loading.addGiro = false;
        })
        .catch(err => {
          this.loading.addGiro = false;

          alert(err.response.data.message);
        });
    },
    deleteClaim(id) {
      axios
        .delete(`invoice/delete-claim/${id}`)
        .then(res => {
          this.fetchClaim();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    deleteGiro(id) {
      axios
        .delete(`invoice/delete-giro/${id}`)
        .then(res => {
          this.fetchGiro();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    updateTglLunasNota() {
      axios
        .put(`invoice/update-tanggal-lunas`, {
          nomor_nota: this.formData.nomor_nota,
          tgl_lunas: this.formData.tgl_lunas
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    updateKeteranganPelunasan() {
      axios
        .put(`invoice/update-keterangan-pelunasan`, {
          nomor_nota: this.formData.nomor_nota,
          keterangan_pelunasan: this.formData.keterangan_pelunasan
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    setInvoiceData(val) {
      this.haveNomorNota = true;

      if (val.kolektor == null) {
        val.kolektor = {
          user_id: ""
        };
      }

      this.formData = val;

      this.fetchClaim();
      this.fetchGiro();
    },
    formatForm() {
      this.haveNomorNota = false;

      this.formData = {
        i_total: 0,
        ii_total: 0,
        biaya_lain_total: 0,
        customer: {
          nama: ""
        },
        kolektor: {
          user_id: ""
        },
        keterangan_pelunasan: "",
        invoice_detil: []
      };

      this.data.claims = [];
      this.data.giros = [];
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    formatDate(data) {
      let date = new Date(data);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  created() {
    this.fetchKolektor();
  }
};
</script>

<style scoped>
.invoice-item {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.overflow-auto {
  overflow: auto !important;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.header .left {
  border: 1px solid black;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}

.detail-table {
  width: 100%;
  font-size: 1rem;
}

.detail-table tr td {
  padding: 2px;
}

th {
  text-align: left;
}

#section-print {
  display: none;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}
</style>
